import KillChainTimeline from './KillChainTimeline';

export default KillChainTimeline;
